import { render, staticRenderFns } from "./openingImage.vue?vue&type=template&id=31dc23ef&"
var script = {}
import style0 from "./openingImage.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31dc23ef')) {
      api.createRecord('31dc23ef', component.options)
    } else {
      api.reload('31dc23ef', component.options)
    }
    module.hot.accept("./openingImage.vue?vue&type=template&id=31dc23ef&", function () {
      api.rerender('31dc23ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/openingImage/openingImage.vue"
export default component.exports